var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-list",
    { attrs: { "no-border": "", link: "" } },
    [
      _c("q-list-header", [
        _vm._v("\n    " + _vm._s(_vm.$t("label.downloadTickets")) + "\n  ")
      ]),
      _vm._l(_vm.filterLinkList, function(ticket, index) {
        return _c(
          "q-item",
          {
            directives: [{ name: "close-overlay", rawName: "v-close-overlay" }],
            key: index,
            attrs: { "data-test": _vm.CypressTarget("Download") },
            nativeOn: {
              click: function($event) {
                _vm.download(ticket.link, ticket.type)
              }
            }
          },
          [
            _c("q-item-main", { attrs: { label: "" } }, [
              _vm._v("\n      " + _vm._s(ticket.type) + "\n    ")
            ])
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }